import * as types from './types';

const INITIAL_STATE = {
  license: {
    Data: [],
    Errors: [],
  },
  licenseExists: undefined,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LICENSE_IMPORT:
    case types.LICENSE_ERROR:
      return { ...state, license: action.payload.data };
    case types.LICENSE_CLEAR_ERROR:
      return { ...state, license: { Errors: undefined } };
    case types.LICENSE_CLEAR_DATA:
      return { ...state, license: { Data: undefined } };
    case types.LICENSE_EXISTS:
      return {
        ...state,
        licenseExists: action.payload.data.Errors.length !== 0 ? false : true,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/license/state/reducer.js